/**
 * The UI string catalog, split per area so each page's wording lives next to nothing
 * else and two people editing different pages never touch the same file.
 *
 * A key is `<area>.<what>`; `common.*` holds the words shared by every screen (Save,
 * Cancel, Delete…). `en` is mandatory and is the fallback for a missing `ru`.
 */
import { COMMON_STRINGS } from './common';
import { NAV_STRINGS } from './nav';
import { AUTH_STRINGS } from './auth';
import { FARMS_STRINGS } from './farms';
import { FARM_DEVICES_STRINGS } from './farm-devices';
import { DEVICES_STRINGS } from './devices';
import { CLICKER_STRINGS } from './clicker';
import { CLICKER_TABS_STRINGS } from './clicker-tabs';
import { USERS_STRINGS } from './users';
import { WORKSPACE_STRINGS } from './workspace';
import { STREAM_STRINGS } from './stream';
import { SHARE_STRINGS } from './share';
import { ADB_PROXY_STRINGS } from './adb-proxy';
import { DASHBOARDS_STRINGS } from './dashboards';
import { SHIFTS_STRINGS } from './shifts';
import { CHARTS_STRINGS } from './charts';
export const LANG_STRINGS = {
    ...COMMON_STRINGS,
    ...NAV_STRINGS,
    ...AUTH_STRINGS,
    ...FARMS_STRINGS,
    ...FARM_DEVICES_STRINGS,
    ...DEVICES_STRINGS,
    ...CLICKER_STRINGS,
    ...CLICKER_TABS_STRINGS,
    ...USERS_STRINGS,
    ...WORKSPACE_STRINGS,
    ...STREAM_STRINGS,
    ...SHARE_STRINGS,
    ...ADB_PROXY_STRINGS,
    ...DASHBOARDS_STRINGS,
    ...SHIFTS_STRINGS,
    ...CHARTS_STRINGS,
};
